export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '产品名称',
    dataIndex: 'title',
  },
  {
    title: '所属公司',
    dataIndex: 'qichacha_name',
  },
  {
    title: '状态',
    customRender: (record)=> record.data.status===1?'启用':'禁用',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'title',
    lable: '产品名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'spec',
    lable: '产品规格',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  // {
  //   name: 'product_form',
  //   lable: '产品剂型',
  //   lableCol: 4,
  //   wrapperCol: 18,
  //   offset: 0,
  //   span: 12,
  // },
  // {
  //   name: 'nmpn',
  //   lable: '国药准字',
  //   lableCol: 4,
  //   wrapperCol: 18,
  //   offset: 0,
  //   span: 12,
  // },
  {
    name: 'department_id',
    lable: '所属科室',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'describe',
    lable: '产品介绍',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
];
